import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { ResourceStatistics } from './ResourceStatistics';

@Injectable()
export class SurveyService {
  questionIndex: any;

  constructor(private http: HttpClient, private config: ConfigService) {
    this.questionIndex = 0;
  }
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
     
    }),
  };


  submitSurvey(survecyObj: any) {
    var postItem = survecyObj;
    return this.http.post(
      this.config.apiUrl + 'Survey/SubmitSurvey',
      postItem,
      this.httpOptions
    );
  }

  submitQuestionResponse(survecyObj: any) {
    var postItem = survecyObj;
    return this.http.post(
      this.config.apiUrl + 'Survey/SaveQuestionResponse',
      postItem,
      this.httpOptions
    );
  }

  cancelSurvey(survecyObj: any) {
    var postItem = survecyObj;
    return this.http.post(
      this.config.apiUrl + 'Survey/EndSurvey',
      postItem,
      this.httpOptions
    );
  }

  referenceClick(resourceStatistics: ResourceStatistics) {
    return this.http.post(
      this.config.apiUrl + 'Survey/UpdateSurveyResource',
      resourceStatistics,
      this.httpOptions
    );
  }
}
